import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ContentApi } from "@app/services/apiServices/ContentApi";
import { take } from "rxjs/operators";

@Component({
    selector: 'app-terms-dialog',
    template: require('./termsDialog.html')
})
export class TermsDialog implements OnInit {
    private terms: string;
    private headerText = 'Agree to Terms and Conditions';

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<TermsDialog>) public dialogRef: MatDialogRef<TermsDialog>,
                @Inject(ContentApi) private contentApi: ContentApi) {
        dialogRef.updateSize("430px");
        if (data?.updated) {
            this.headerText = 'Agree to Updated Terms and Conditions';
        }
    }

    ngOnInit() {
        this.contentApi.fetchGlobalContentByLocationType('pptos').pipe(take(1))
            .subscribe({ next: resp => {
                this.terms = decodeURIComponent(resp.msg);
            } });
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value);
    }
}
